import { AuthorResponse } from "../../types/api/common"
import { Avatar, Stack, Text } from '@primer/react'
import { ChevronRightIcon } from '@primer/octicons-react';

interface UserHeaderCardProps {
    user: AuthorResponse | null
    isLarge: boolean
    isSupport: boolean
    onClick?: () => void;
}

export const UserHeaderCard: React.FC<UserHeaderCardProps> = ({ user, isLarge, isSupport = false, onClick }) => {

    const handleAvatarError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = "/icons/avatar.png";
    };

    const isNotRegisteredUser = () => {
        if (user === null) {
            return true
        }
        return (user?.username === 'Unknown User' && user.phone == null) ? true : false
    }

    const userInfo = () => {
        if (isSupport) {
            return 'Служба поддержки'
        }
        return (
            <>
                {user && user.phone && <span>{user.phone}</span>}
                {user && user.phone && user.email && <span> · </span>}
                {user && user.email && <span>{user.email}</span>}
            </>
        )
    }

    return (
        <Stack justify="space-between" direction="horizontal">
            <Stack direction="horizontal" align="center">
                <Avatar
                    src={isSupport ? '/icons/logo.png' : (user?.avatar?.preview ?? "/icons/avatar.png")}
                    alt="avatar"
                    size={40}
                    className='w-[40}px] aspect-square object-cover object-center rounded-full'
                    onError={handleAvatarError}
                />
                <Stack gap='none'>
                    {
                        (isNotRegisteredUser() && !isSupport) && (
                            <Text
                                as="span"
                                weight='medium'
                                className='text-[14px] text-aloix-black'
                            >
                                Гость
                            </Text>
                        )
                    }
                    {
                        isSupport && (
                            <Text
                                as="span"
                                weight='medium'
                                className='text-[14px] text-aloix-black'
                            >
                                Aloix
                            </Text>
                        )
                    }
                    {
                        (!isSupport && !(isNotRegisteredUser())) && (
                            <>
                                {isLarge && <ChevronRightIcon className="absolute right-0 mr-8 " size={16} />}
                                <div
                                    onClick={!isLarge ? onClick : undefined}
                                    className={`!h-[24px] -ml-2 flex items-center justify-between px-2 rounded max-w-fit ${!isLarge ? 'cursor-pointer hover:bg-gray-100' : ''
                                        }`}
                                >
                                    <Text
                                        as="span"
                                        weight='medium'
                                        className='text-[14px] text-aloix-black mr-1'
                                    >
                                        {user?.username}
                                    </Text>
                                    {!isLarge && <ChevronRightIcon size={16} />}
                                </div>
                            </>
                        )
                    }
                    <Text
                        as="span"
                        weight='medium'
                        className='text-[14px] text-aloix-grey mr-2'
                    >
                        {userInfo()}
                    </Text>
                </Stack>
            </Stack>
        </Stack>
    )
}
